import type { AppLocale } from "@/i18n/config";
type PublicSlugs = {
  slug_en_published?: string | null;
  slug_fa_published?: string | null;
  slug_en?: string | null;
  slug_fa?: string | null;
  status?: string | null;
};
export function articlePageUrl(
  content: PublicSlugs | null | undefined,
  locale: AppLocale,
  fallbackSlug?: string | null,
) {
  if (!content || (content.status && content.status !== "published"))
    return null;
  const explicitPublished =
    "slug_en_published" in content || "slug_fa_published" in content;
  const get = (lang: AppLocale) =>
    explicitPublished
      ? content[`slug_${lang}_published`]
      : content[`slug_${lang}`];
  let destinationLocale = locale;
  let slug = get(locale);
  if (!slug) {
    destinationLocale = locale === "fa" ? "en" : "fa";
    slug = get(destinationLocale);
  }
  if (!slug && fallbackSlug) {
    destinationLocale = locale;
    slug = fallbackSlug;
  }
  return slug ? `/${destinationLocale}/c/${encodeURIComponent(slug)}` : null;
}
